export default __webpack_public_path__ + "static/media/ID_LABORATORY_GLUPS.dbaf5398.jpg";